import React, { useState } from "react";
import Box from "@mui/material/Box";
import { TextField } from "@mui/material";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Pencil, Trash, X } from "lucide-react"; // Assuming you're importing these icons correctly
import { Permissions } from "../../../../permissions";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 573,
  bgcolor: "background.paper",
  border: "2px solid #ffffff",
  boxShadow: 24,
  borderRadius: 2,
};

const PosterBox = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  let editposter =
    Permissions.find(permission => permission.includes("edit_poster")) !==
    undefined;

  let Deleteposter =
    Permissions.find(permission => permission.includes("delete_poster")) !==
    undefined;

  return (
    <div className="flex flex-col box-border w-full border border-zinc-200 shadow-lg ring-black rounded-lg">
      <div className="flex items-center justify-center">
        <img
          src={require("../../../../assets/poster.png")}
          alt="Product image"
          className="w-[15.8888vw] h-[16.9999vh]"
        />
      </div>

      <div className="font-outfit font-medium text-[#333333] text-[13px] text-center mt-3">
        Validity: 13/10/23 - 25/11/23
      </div>

      <hr className="border-[0.712px] border-zinc-400 w-[90%] mx-auto my-2" />

      <div className="flex flex-row box-border w-full rounded-lg mb-2 px-2 my-2">
        <div className="w-[60%] h-[100% box-border flex items-center px-[3.220338983%] justify-start text-[1.9vh] font-medium font-outfit"></div>
        <div className="w-[40%] h-[100%] box-border flex flex-row items-start justify-end pr-2">
          <div className="ml-[0.69444vw] h-[60%] rounded-xl flex flex-row gap-x-2 items-center justify-center">
            {editposter ? (
              <button
                onClick={handleOpen}
                className="text-sm flex flex-row text-[#ffffff] p-[3px] rounded-md shadow-md ring-black bg-[#ECE6F0] items-center justify-center">
                <Pencil
                  color="#6750A4"
                  size={16}
                  className="mx-1 h-[16px] w-[16px]"
                />
              </button>
            ) : (
              <button className="text-sm flex flex-row text-[#ffffff] p-[5px] rounded-md bg-[#acacac1A] items-center justify-center">
                <Pencil
                  color="#acacac"
                  size={16}
                  className="mx-1 h-[16px] w-[16px]"
                />
              </button>
            )}

            {Deleteposter ? (
              <button className="text-sm flex flex-row text-[#ffffff] p-[3px] rounded-md shadow-md ring-black bg-[#ECE6F0] items-center justify-center">
                <Trash color="red" className="mx-1 h-[16px] w-[16px]" />
              </button>
            ) : (
              <button className="text-sm flex flex-row text-[#ffffff] p-[3px] rounded-md bg-[#acacac1A] items-center justify-center">
                <Trash color="#acacac" className="mx-1 h-[16px] w-[16px]" />
              </button>
            )}
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="flex flex-row box-border w-full border-b-[0.5px] border-zinc-600 my-2">
            <div className="w-[60%] h-[100%] box-border flex items-center py-2 px-[3.220338983%] justify-start text-[20px] font-medium font-outfit">
              Edit
            </div>
            <div className="w-[40%] h-[100%] mt-2 box-border flex flex-row items-start justify-end pr-2">
              <div className="ml-[0.69444vw] h-[60%] rounded-xl flex flex-row gap-x-2 items-center justify-center">
                <button
                  onClick={handleClose}
                  className="text-sm flex flex-row text-[#ffffff] p-[3px] rounded-md shadow-md ring-black bg-[#ECE6F0] items-center justify-center">
                  <X
                    color="#000"
                    size={18}
                    className="mx-1 h-[18px] w-[18px]"
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start justify-center box-border ">
            <div className="w-[100%] h-[80%] mt-[1.959259259vh] box-border px-[3.220338983%] ">
              <TextField
                id="outlined-basic"
                label="Brand"
                variant="outlined"
                className="border-dotted w-[80%]"
                size="small"
              />
            </div>
          </div>

          <div className="flex items-start justify-start flex-col">
            <fieldset className="flex items-center justify-center flex-col w-[10.708333vw] pb-[4.186111vh] mx-[1.22222vw]  mt-[1.059259259vh] box-border border-dotted border-2 rounded-md border-[#79747E]">
              <legend className="ml-[0.388vw] text-[14px] font-outfit font-medium text-[#49454F]">
                Image
              </legend>
              <img
                src={require("../../../../assets/upload.png")}
                alt="upload here"
                className="pt-[3.9814814vh]"
              />
              <p className="font-poppins text-[14px] font-medium mt-[1.42%] text-[#79747E]">
                Browse Upload
              </p>
            </fieldset>
            <p className="flex items-center justify-center mx-[1.52222vw] text-[14px] mt-2 font-outfit font-normal">
              *Preffered ratio- 1:1
            </p>
          </div>

          <div className="flex flex-row mt-5 items-start justify-start mx-[1.522222vw] gap-x-3 pb-4">
            <button
              onClick={handleClose}
              className="border-[1px] border-zinc-300 rounded-md px-5 py-2 text-[2.2vh] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row">
              {" "}
              <span className="px- text-[#5652B0] px-3">Cancel</span>
            </button>
            <button className="border-2 border-purple-700 rounded-md px-9 py-2 text-[2.2vh] font-medium font-outfit flex items-center justify-center flex-row bg-[#5652B0]">
              {" "}
              <span className="px-2 text-white ">Save</span>
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default PosterBox;
